import _extends from 'babel-runtime/helpers/extends';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';


var getRandomString = function getRandomString(charNumber) {
  return Math.random().toString(36).substring(charNumber);
};

/**
 * Triggers a message-bus transport command, and calls callback after receiving response.
 * @param {object} commandData - message-bus publish event data
 * @param {object} responseData  - message-bus subscribe event data
 * @return {void}
 */
export var triggerCommand = function triggerCommand(commandData, _ref) {
  var responseTopic = _ref.topic,
      responseCallback = _ref.callback;

  var correlationId = '@myacc/' + getRandomString(6);
  var subscriptionId = subscribe({
    topic: responseTopic,
    callback: function callback(env) {
      var headers = env.headers;

      if (headers.correlationId === correlationId) {
        responseCallback(env);
        unsubscribe(subscriptionId);
      }
    }
  });
  publish(_extends({}, commandData, {
    headers: {
      correlationId: correlationId
    }
  }));
};